// eslint-disable-next-line import/no-unresolved
const utils = require('onestic-base/utils');
const constants = require('onestic-base/constants');
const lozad = require('lozad');

let isMouseHover = false;
let focusHandlersBound = false;

const updateCurrentProductState = (container) => {
    const $productContainer = $(container).parent();
    const tileBtn = $productContainer.find('.cart-and-ipay .show-button');
    const isSet = $productContainer.find('.btn-product-set').length;
    const $productStock = $productContainer.find('.productStock');
    const quickShoppingAvailable = $productContainer.find('.quickShoppingAvailable');
    const quickShoppingOutOfStockTitle = $productContainer.find('.quickShoppingOutOfStockTitle');
    const renderedData = {
        id: $productContainer.find('.quickShoppingId').val(),
        availability: quickShoppingAvailable.length
            ? JSON.parse(quickShoppingAvailable.val()) : null,
        outOfStockTitle: quickShoppingOutOfStockTitle.length
            ? quickShoppingOutOfStockTitle.val() : null,
        productStock: $productStock.length
            ? JSON.parse($productStock.val()) : null,
    };

    tileBtn.attr('data-pid', renderedData.id);

    // check availability for create button outOfStock
    if (!renderedData.availability && $('#siteAvailableOutOfstock').val() !== 'false' && !isSet) {
        tileBtn.removeClass('add-to-cart-globalGrid add-to-cart-grid-marshall');
        tileBtn.addClass('outofstock-button outofstock-mobile');
        tileBtn.html(renderedData.outOfStockTitle);
    }

    if (renderedData.productStock && typeof renderedData.productStock === 'object') {
        const siteLastItemsConfig = parseInt($('#siteLastItemsConfig').val(), 10);

        renderedData.productStock[0].values.forEach((val) => {
            const prodAttributes = $productContainer.find(
                `a[data-attr-value="${val.id}"]`,
            );

            if (val.stock[val.id] <= siteLastItemsConfig && val.stock[val.id] !== 0) {
                prodAttributes.addClass('lastItems');

                if (!prodAttributes.find('.message-last-items').length) {
                    const lastItemsMessageTooltip = $('#lastItemsMessageTooltip').val();
                    const lastItemsDiv = `<div class="message-last-items tooltip">${lastItemsMessageTooltip}</div><span class="circle-red"></span>`;

                    prodAttributes.append(lastItemsDiv);
                }
            }

            if (!val.stock[val.id]) {
                prodAttributes.addClass('outofstock icon-email-line');
            }
        });
    } else if (renderedData.productStock) {
        const siteLastItemsConfig = parseInt($('#siteLastItemsConfig').val(), 10);
        const prodSimpleTextLastItems = $productContainer.find('.last-items-simple');

        if (prodSimpleTextLastItems.length && (renderedData.productStock <= siteLastItemsConfig)) {
            prodSimpleTextLastItems.removeClass('d-none');
        }
    }
};

const checkElementsToShow = (container, showTileFooter) => {
    const $container = $(container);
    const allAttributes = $container.find('.tile-body-footer-buy .attributes div[data-attr]');
    const commonAttributes = $container.find('.tile-body-footer-buy .attributes div[data-attr]:not(.d-none)');
    const commonAttributesSelected = commonAttributes.find('.attributeSelected').length;
    const swatchAttributes = $container.find('.attr-swatch-list');
    const swatchAttributesSelected = swatchAttributes.find('a.selected').length;
    const attributeCount = swatchAttributes.length;
    const $button = $container.find('.add-to-cart-grid-marshall , .outofstock-button, .btn-product-set');
    const productOptions = $container.find('.product-option');
    const productOptionsCount = productOptions.length;
    const showAddToCartButton = $('#showAddToCartButton');
    const isBundle = $(container).find('.bundle-button').length;
    const totalAttributesCount = allAttributes.length;
    const totalAttributesSelectedCount = commonAttributesSelected + swatchAttributesSelected;

    if (commonAttributes.length >= 1 || productOptionsCount > 0) {
        if (productOptionsCount > 0) {
            $container.find('.product-option').fadeIn('fast');
        }

        if (commonAttributes.length >= 1) {
            $container.find('.attributes').fadeIn('fast');
        }

        if (showTileFooter) {
            const tileFooterBuy = $container.find('.tile-body-footer-buy');
            tileFooterBuy.addClass('show-attrs');
            if (tileFooterBuy.hasClass('slide')) {
                tileFooterBuy.slideDown('fast');
            } else {
                tileFooterBuy.fadeIn('fast');
            }
        }
    }

    if (attributeCount > 1) {
        if (!$container.find('.attr-swatch-list-wrapper').length) {
            $container.find('.container-swatches > .swatches.row .attr-swatch-list:not(:first-child)').wrapAll('<div class="attr-swatch-list-wrapper" />');
        }
        $container.find('.attr-swatch-list, .attr-swatch-list-wrapper').fadeIn('fast');
    }

    if ((commonAttributes.length === 0 && attributeCount === 0)
        || (attributeCount >= 1
        && attributeCount === swatchAttributesSelected
        && commonAttributes.length === 0)
        || (showAddToCartButton.length && showAddToCartButton.val() === 'true')) {
        if (isBundle) {
            $button.removeClass('d-none');
            $('.bundle-button-out').addClass('d-none');
        }
        $button.addClass('show-button').parents('.cart-and-ipay').fadeIn();
    }

    if (((commonAttributes.length === commonAttributesSelected)
        || (attributeCount === swatchAttributesSelected))
        && totalAttributesCount === totalAttributesSelectedCount) {
        $button.removeAttr('disabled');
        $button.removeClass('disabled');
    } else {
        $button.attr('disabled', true);
        $button.addClass('disabled');
    }
};

const triggerAddToCart = (productDetail, typeAttribute) => {
    const tileFooterBuyHtmlEmpty = 2500;
    const siteAvailableOutOfstock = $('#siteAvailableOutOfstock').val();

    setTimeout(() => {
        const thisParent = productDetail.parents('.tile-body');
        const typeAttrCapitalized = `${typeAttribute.charAt(0).toUpperCase()}${typeAttribute.slice(1)}`;

        if (thisParent.length) {
            const thisTargetButton = thisParent.find('.cart-and-ipay .add-to-cart-grid-marshall');
            const showAddToCartButton = $('#showAddToCartButton');

            if (productDetail.hasClass('outofstock') && !productDetail.hasClass('gridSwatch')) {
                // eslint-disable-next-line global-require
                const outOfStock = require('onestic-base/product/outOfStock');
                const pid = thisParent.find('.product-detail:not(".bundle-item")').data('pid');

                if (showAddToCartButton.length && showAddToCartButton.val() === 'true') {
                    thisTargetButton.parents('.cart-and-ipay').fadeIn();
                } else {
                    outOfStock.showOutofStockGrid(pid);
                }
            } else {
                checkElementsToShow(thisParent[0], false);

                if (!thisTargetButton.is(':disabled')) {
                    const attributesCount = thisParent.find('.attributes > .swatch').length;
                    const selectedAttributesCount = thisParent.find('.attr-swatch-list .selected').length
                        + thisParent.find('.attributes > .swatch:not(.d-none) .attributeSelected').length;
                    if (thisTargetButton.hasClass('show-button')
                        || (showAddToCartButton.length && showAddToCartButton.val() === 'true')) {
                        thisTargetButton.parents('.cart-and-ipay').fadeIn();
                    } else if (attributesCount === selectedAttributesCount) {
                        thisTargetButton.trigger('click');
                    }
                } else {
                    thisParent.find('.container-swatches .select-swatch-message').fadeIn(() => {
                        $('.select-swatch-message').delay(2000).fadeOut();
                    });
                }
            }
        }

        if (siteAvailableOutOfstock === 'true' && thisParent.find('.cart-and-ipay').css('display') === 'none') {
            const allSizeLinks = $(`.attributeLink[data-type="select-${typeAttribute}"],.attributeLink[data-type*="${typeAttribute}"], .attributeLink[data-type*="${typeAttrCapitalized}"]`);
            allSizeLinks.removeClass('unselectable');
        }
    }, tileFooterBuyHtmlEmpty);
};

function quickShoppingChangeSwatchAttribute(node) {
    const $node = $(node);
    const swatchAttr = $node.attr('data-attr-value');

    if (swatchAttr) {
        const spanNode = $node.find('span');
        const $nodeParent = $node.parent();
        const previousSelected = spanNode.hasClass('selected');
        const attrType = $node.parent().attr('data-type');
        const $attrLinkContainer = $node
            .closest('.tile-body')
            .find(`[data-attr=${attrType}]`);


        $nodeParent
            .find('a.gridSwatch')
            .removeClass('selected');

        $attrLinkContainer.find(`[data-attr-value="${swatchAttr}"]`).parents('a').trigger('click');

        if (!previousSelected) {
            $node.parents('.container-swatches.position-relative')
                .find(`a.gridSwatch[data-attr-value="${swatchAttr}"]`)
                .addClass('selected');
        }

        const desktopEvent = window.outerWidth > constants.viewport_bootstrap.lg;
        if (desktopEvent) {
            // the attributes unselectables must not trigger the add to cart
            if (!node.parents('.product').find('a.selected.unselectable, a.no-add-to-cart').length) {
                triggerAddToCart(node, attrType);
            } else {
                checkElementsToShow(node.parents('.product'), false);
            }
        }
    }
}

function quickShoppingChangeSecondVariation(node) {
    const $node = $(node);
    $node
        // eslint-disable-next-line consistent-return
        .on('click', '.attributeLink', (e) => {
            const thisTarget = $(e.currentTarget);

            const targetParent = thisTarget.parent();
            const attrSelected = thisTarget.attr('data-attr-value');
            const selectedTypeAttribute = thisTarget.attr('data-type');
            const $select = $node.find(`select[class*=${selectedTypeAttribute}]`);
            const typeAttribute = targetParent.parent().attr('data-attr');

            targetParent
                .find('.attributeSelected')
                .removeClass('attributeSelected');
            targetParent
                .find('.isactive')
                .removeClass('isactive');

            thisTarget.addClass('attributeSelected');
            thisTarget.addClass('isactive');

            thisTarget.parent()
                .find('option')
                .attr('selected', false);

            $node
                .find(`option[data-attr-value="${attrSelected}"]`)
                .attr('selected', 'selected');

            $select.trigger('change');
            thisTarget.addClass('selected');

            triggerAddToCart(thisTarget, typeAttribute);
        });
}

function getData(data, url) {
    const defer = $.Deferred();
    $.ajax({
        url,
        type: 'GET',
        data,
    }).done((response) => {
        defer.resolve(response);
    });

    return defer;
}

function hideQuickShopping(container) {
    const isPLP = $(container).parents('.product-grid, #search-results, #product-compare-modal');
    const tileParent = isPLP.length ? isPLP : $(container).parents('.product-carousel');
    const hideElement = tileParent.find('.tile-body-footer-buy, .attributes, .attr-swatch-list-wrapper, .cart-and-ipay, .product-option');
    if (tileParent.find('.tile-body-footer-buy').hasClass('slide')) {
        hideElement.slideUp('fast');
    } else {
        hideElement.fadeOut('fast');
    }
    tileParent.find('.tile-body-footer-buy').removeClass('show-attrs');
}

const swatchesShowMoreTrigger = (target) => {
    const divAllVariations = target.find('.container-swatches .swatch-hidden');
    const showIcon = target.find('.show-more-swatches');

    divAllVariations.toggleClass('active');
    if (divAllVariations.hasClass('active')) {
        showIcon.removeClass('icon-zoom-plus');
        showIcon.addClass('icon-zoom-minus');
    } else {
        showIcon.removeClass('icon-zoom-minus');
        showIcon.addClass('icon-zoom-plus');
    }
};

// Add Variation master options for Variation Group products type
function updateGroupVariationSwatches(container, desktopEvent) {
    const productTile = $(container);

    if (productTile.hasClass('variation-group-tile')) {
        const attrID = productTile.find('.attr-swatch-list').attr('data-type');
        const tileFooterSwatches = productTile.find(`.detail-panel-grid .attributes [data-attr="${attrID}"] .attribute .hidden-swatches-container`);
        const tileFooterSwatchesLinks = tileFooterSwatches.find('a').length;

        if (tileFooterSwatchesLinks) {
            const groupVariations = productTile.find('.container-swatches .attr-swatch-list');
            const tileFooterSwatchesHTML = tileFooterSwatches.html();
            const newGtmVariationsData = productTile.find('.gtmProdVariationsUpdater');

            groupVariations.find('a.gridSwatch').remove();
            groupVariations.append(tileFooterSwatchesHTML);
            productTile.find('.gtmProdVariations').data('pinfo', newGtmVariationsData);

            if (!desktopEvent) {
                swatchesShowMoreTrigger(container);
            }
        }
    }
}

function showQuickShopping(quickShopping, container, desktopEvent, currentTarget) {
    const $content = $(container).find('.tile-body-footer-buy');
    const contentEmpty = $content.is(':empty');
    if (contentEmpty) {
        const url = $(container)
            .find('.quickview')
            .attr('href');
        const data = {
            quickShopping,
        };
        const promise = getData(data, url);
        promise.done((response) => {
            const $contentAfterResponse = $(container).find('.tile-body-footer-buy');
            const contentAfterResponseEmpty = $contentAfterResponse.is(':empty');
            if (contentAfterResponseEmpty) {
                $contentAfterResponse
                    .empty()
                    .append(response);
                checkElementsToShow(container, true);
                updateGroupVariationSwatches(container, desktopEvent);
                quickShoppingChangeSecondVariation(container);
                updateCurrentProductState(container);
            }

            if (!desktopEvent) {
                quickShoppingChangeSwatchAttribute(currentTarget);
            }

            if (!isMouseHover && !$(container).find(':focus').length) {
                hideQuickShopping(container);
            }
        });
    } else {
        checkElementsToShow(container, true);

        if (!desktopEvent) {
            quickShoppingChangeSwatchAttribute(currentTarget);
            swatchesShowMoreTrigger(container);
        }
    }
}

function assignQuickShopping() {
    const docBody = $(document.body);
    const quickShopping = utils.getCookie('quickShopping');
    if (quickShopping !== 'false') {

        docBody.on('click', '.product-bundle-outofstock-button, .outofstock-button', (e) => {
            // eslint-disable-next-line global-require
            const outOfStock = require('onestic-base/product/outOfStock');
            const pid = $(e.currentTarget).data('pid');
            e.stopPropagation();
            outOfStock.showOutofStockGrid(pid);
        });

        const desktopEvent = window.outerWidth > constants.viewport_bootstrap.lg;
        if (desktopEvent) {
            docBody.on('click', '.product-tile .gridSwatch.no-add-to-cart.selected, .product-tile .attributeLink.no-add-to-cart.selected', (e) => {
                e.stopPropagation();
                e.preventDefault();
            });

            docBody.on('click', '.product-tile .gridSwatch:not(.selected), .product-tile .attributeLink:not(.selected)', (e) => {
                e.stopPropagation();
                e.preventDefault();
                quickShoppingChangeSwatchAttribute($(e.currentTarget));
            });

            docBody.on('mouseenter', '.product-tile', (e) => {
                e.stopPropagation();
                isMouseHover = true;
                const thisTarget = $(e.currentTarget);
                showQuickShopping(quickShopping, thisTarget, desktopEvent, thisTarget);
                utils.displayFuturePromotionsInfo(thisTarget);
            });

            docBody.on('mouseleave', '.product-tile', (e) => {
                e.stopPropagation();
                isMouseHover = false;
                const thisTarget = $(e.currentTarget);
                if (e.target.nodeName.toLowerCase() !== 'select' && !thisTarget.find(':focus').length) {
                    hideQuickShopping(thisTarget);
                }
            });

            if (!focusHandlersBound) {
                focusHandlersBound = true;

                document.addEventListener('focusin', (e) => {
                    const tile = e.target.closest('.product-tile');
                    if (!tile) return;
                    isMouseHover = true;
                    const thisTarget = $(tile);
                    showQuickShopping(quickShopping, thisTarget, desktopEvent, thisTarget);
                    utils.displayFuturePromotionsInfo(thisTarget);
                }, true);

                document.addEventListener('focusout', (e) => {
                    const tile = e.target.closest('.product-tile');
                    if (!tile) return;
                    setTimeout(() => {
                        if (!$.contains(tile, document.activeElement) && document.activeElement !== tile) {
                            isMouseHover = false;
                            if (document.activeElement.nodeName.toLowerCase() !== 'select') {
                                hideQuickShopping($(tile));
                            }
                        }
                    }, 10);
                }, true);
            }

            docBody.on('mouseenter', '.attributeLink, .gridSwatch', (e) => {
                e.stopPropagation();
                const thisTarget = $(e.currentTarget);
                if (thisTarget.hasClass('lastItems')) {
                    thisTarget.find('.message-last-items').addClass('active');
                }
            });

            docBody.on('mouseleave', '.attributeLink, .gridSwatch', (e) => {
                e.stopPropagation();
                const thisTarget = $(e.currentTarget);
                if (thisTarget.hasClass('lastItems')) {
                    thisTarget.find('.message-last-items').removeClass('active');
                }
            });

            docBody.on('click', '.swatches .show-more-swatches-wrapper', (e) => {
                const target = $(e.currentTarget);

                swatchesShowMoreTrigger(target.parents('.product-tile'));
            });
        } else {
            docBody.on('click', '.gridSwatch:not(.selected)', (e) => {
                e.stopPropagation();
                e.preventDefault();
                const currentTarget = $(e.currentTarget);
                const $productTile = currentTarget.parents('.product-tile');

                showQuickShopping(quickShopping, $productTile, desktopEvent, currentTarget);
            });

            docBody.on('click', '.swatches .show-more-swatches-wrapper', (e) => {
                const currentTarget = $(e.currentTarget);
                const $productTile = currentTarget.parents('.product-tile');

                showQuickShopping(quickShopping, $productTile, desktopEvent, currentTarget);
            });

            //Quickshopping estático en mobile
            const observer = lozad('.product-tile', {
            rootMargin: '200px',
            load: function(el) {
                showQuickShopping(quickShopping, el, desktopEvent, el);
            }
            });
            observer.observe();
        }
    }
}

module.exports = {
    assignQuickShopping,
};
